import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { SEOHead } from '../components/site/SEOHead';
import api from '../lib/api';

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/legal-pages/${slug}`)
      .then(r => setPage(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>;
  if (notFound || !page) return <div className="min-h-screen flex flex-col items-center justify-center"><p className="text-muted-foreground mb-4">Sayfa bulunamadı</p><Link to="/" className="text-[hsl(var(--gold))]">Anasayfaya dön</Link></div>;

  return (
    <div data-testid="legal-page">
      <SEOHead title={page.title} />
      {/* Hero */}
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">{page.title}</h1>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          {(() => {
            const c = page.content || '';
            const isHtml = /<\/?[a-z][\s\S]*>/i.test(c);
            const hasText = c.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
            if (!hasText) return <p className="text-muted-foreground">Bu sayfada henüz içerik yok.</p>;
            return isHtml
              ? <div className="rich-content max-w-none" dangerouslySetInnerHTML={{ __html: c }} />
              : <p className="text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-line">{c}</p>;
          })()}
        </div>
      </section>
    </div>
  );
}
